import { getField, updateField } from 'vuex-map-fields'
import store from '@/store'

const getDefaultFilter = () => ({
  page: 1,
  offset: 0,
  limit: 10,
  sort: 'R',
  advanced: false, // Panneau recherche avancé ouvert
  search: '', // Recherche
  type: null, // Type de logement
  sellType: null, // Vente | Location
  published: null, // Visibles / désactivées
  priceGt: 0,
  priceLt: null,
  dateCreationGt: null,
  dateCreationLt: null,
  objectTypes: [],
  annoncesActivees: true,
  annoncesDesactivees: null,
  annoncesSupprimees: null,
  annoncesModeles: null,
  annonceParente: null,
  mandates: [], // Type de mandat
  surfaceGt: null,
  surfaceLt: null,
  stock: null,
  offerTypes: [],
  typeObjets: [],
  withoutPictures: null,
  creationProgramme: null,
  preset: 'enable',
  annoncesDiffusees: null
  // millesime: null,
  // modele: null,
  // marque: null,
})

const getPresetFilters = () => ({
  preset: 'enable'
})

export default {
  namespaced: true,
  state: {
    refreshProgramme: false,
    post: { code_postal_reel: 30 }, // dans le cas ou l'on crée ou édit une annonce
    tabs: [],
    filter: getDefaultFilter(),
    results: { total: -1, list: [] } // Stockage des derniers résultats pour accélérer le retour arrière
  },
  getters: {
    getPostField (state) {
      return getField(state.post)
    },
    getRefreshProgramme (state) {
      return state.refreshProgramme
    },
    getCreationProgramme (state) {
      return state.creationProgramme
    }
  },
  mutations: {
    updatePostField (state, field) {
      updateField(state.post, field)
    },
    setPost (state, post) {
      state.post = post
    },
    setTabs (state, tabs) {
      state.tabs = tabs
    },
    setObjectType (state, objectType) {
      state.post.typeObjet = objectType
    },
    setObjectTypeFilter (state, filter) {
      state.filter.typeObjets = filter
    },
    setAnnonceParente (state, annonceParente) {
      state.filter.annonceParente = annonceParente
    },
    setOfferType (state, offerType) {
      state.post.typeOffre = offerType
    },
    setCreationProgramme (state, creationProgramme) {
      state.filter.creationProgramme = creationProgramme
    },
    setPage (state, page) {
      state.filter = { ...state.filter, page }
    },
    setLimit (state, limit) {
      state.filter = { ...state.filter, limit, page: 1 }
    },
    setOffset (state, offset) {
      state.filter = { ...state.filter, offset, page: 1 }
    },
    setSort (state, sort) {
      state.filter = { ...state.filter, sort, page: 1 }
    },
    setSearch (state, search) {
      state.filter = { ...state.filter, search, page: 1 }
    },
    addFilter (state, filter) {
      state.filter = { ...state.filter, ...filter }
      store.commit('postsListImmo/SET_OBJECT_TYPE', filter.objectTypes)
    },
    setFilter (state, filter) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...filter
      }
    },
    resetFilter (state) {
      state.filter = getDefaultFilter()
      state.results = { total: -1, list: [] }
    },
    resetPresetFilters (state) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...getPresetFilters()
      }
    },
    setResults (state, results) {
      state.results = results
    },
    setRefreshProgramme (state, refreshProgramme) {
      state.refreshProgramme = refreshProgramme
    }
  }
}
